export default __webpack_public_path__ + "static/media/play-circle.4abcb5f2.svg";